export const eventMixin = {
  data() {
    return {
      modalEditMode: false,
      editParticipant: null,
    };
  },
  computed: {
    invitations() {
      return this.poll.invitations;
    },

    showEventCounts() {
      if (this.isOwner) return true;

      if (this.poll.options.hiddenPoll) {
        return this.poll.options.showCounts;
      }
      return true;
    },

    confirmations() {
      let count = 0;
      console.log('init  confirmations:', count);
      for (const p of this.participants) {
        console.log('confirmations:', count);
        if (p.choice > 0) {
          if (p.choice == 1) {
            count = count + 1;
          } else {
            count = count + Number(p.guests) + 1;
            console.log('choice 2', count, p.guests);
          }
        }
      }
      console.log('final confirmations:', count);
      return count;
    },

    guests() {
      let count = 0;
      console.log('init  confirmations:', count);
      for (const p of this.participants) {
        console.log('confirmations:', count);
        if (p.choice == 2) {
            count = count + Number(p.guests);
            console.log('choice 2', count, p.guests);
          }
        }
      console.info('guest count:', count);
      return count;
    },

    declines() {
      let count = Number(0);
      for (const p of this.participants) {
        if (p.choice == 0) {
          count++;
        }
      }
      return count;
    },

    //  openEventInvitations() {
    //    let count = Number(0);
    //    for (const invitation of this.invitations) {
    //      if (invitation.participant_id === null) {
    //        count++;
    //      }
    //    }
    //    return count;
    //  },

    openEventInvitations() {
      let count = Number(0);
      for (const p of this.participants) {
        if (p.choice == -1) {
          count++;
        }
      }
      return count;
    },
  },

  methods: {
    isAnswered(participant) {
      if (participant.choice >= 0) return true;
      if (participant.comment && participant.comment.length > 0) return true;
      return false;
    },
    onUpdate(participant) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('updateParticipant', participant)
          .then(resolve(participant))
          .catch((e) => {
            console.error(e);
            reject();
          });
      });
    },

    editParticipantChoices(participant, event) {
      if (!this.isPollEditable) return;
      if (this.isEditable(participant)) {
        this.$refs.dlgEditEventChoice.openModal(participant, event);
      }
    },
  },
};
